var React = require('react');

function OperationPlus (props) {
    return React.createElement("svg",props,React.createElement("g",{"opacity":"0.8"},React.createElement("path",{"d":"M9.02556 6.97403H13.6409C14.2074 6.97403 14.6666 7.43323 14.6666 7.99967C14.6666 8.56612 14.2074 9.02532 13.6409 9.02532H9.02556V13.6407C9.02556 14.2071 8.56636 14.6663 7.99992 14.6663C7.43347 14.6663 6.97428 14.2071 6.97428 13.6407V9.02532H2.35889C1.79245 9.02532 1.33325 8.56612 1.33325 7.99967C1.33325 7.43323 1.79245 6.97403 2.35889 6.97403H6.97428V2.35865C6.97428 1.7922 7.43347 1.33301 7.99992 1.33301C8.56636 1.33301 9.02556 1.7922 9.02556 2.35865V6.97403Z","fill":"white"})));
}

OperationPlus.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = OperationPlus;

OperationPlus.default = OperationPlus;
